import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { BaseCopySdkModel } from './base';
import set from 'lodash/set';
import { cloneDeep } from '@tencent/slide-sdk-model/src/utils/clone-deep';
import { ICopiedPageData } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import {
    DataType,
    IDrawingShapeDataModel,
    ILayoutData,
    IMasterData,
    IPageDataModel,
    ISlideData,
} from '@tencent/slide-sdk-model';
import { GroupCopySdkModel } from './group';
import { ICopySdkModelConfig } from '../../index.interface';

type IPageModel = ISlideModel | ILayoutModel | IMasterModel;
type IPageSdkData = ISlideData | ILayoutData | IMasterData;

export class PageCopySdkModel extends BaseCopySdkModel {
    private pageModel: IPageModel;

    public constructor(model: IPageModel) {
        super(model);
        this.pageModel = model;
    }
    /**
     * 复制时候使用的sdk model
     */
    public getCopiedSdkModel(config: ICopySdkModelConfig = {}): ICopiedPageData | undefined {
        const { sdkData: sdkDataModel } = this.pageModel;
        if (!sdkDataModel) return;

        const cloneSdkData = super.getCopiedSdkModel(config) as ICopiedPageData | undefined;
        if (!cloneSdkData) return;

        // 修正继承数据
        if (!config.withoutInheritedData) {
            this.recursiveCopiedSdkModelForData(cloneSdkData.inheritedSdkData, sdkDataModel);
        }

        return cloneSdkData;
    }

    private recursiveCopiedSdkModelForData(inheritedSdkData: IPageSdkData, pageSdkModel: IPageDataModel) {
        if (!inheritedSdkData.cSld.spTree?.shapeList) {
            set(inheritedSdkData, 'cSld.spTree.shapeList', []);
        }
        pageSdkModel.shapeList?.forEach((shapeDataModel: IDrawingShapeDataModel) => {
            const cloneInheritedData = cloneDeep(shapeDataModel.getInheritedData());
            inheritedSdkData.cSld.spTree?.shapeList.push(cloneInheritedData);

            if (shapeDataModel.type === DataType.GroupShape) {
                GroupCopySdkModel.recursiveCopiedGroupSdkData(cloneInheritedData, shapeDataModel);
            }
        });
    }
}
